import React, { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom'
import {
  Typography,
  IconButton as IconBut,
  Button,
  Box,
  Toolbar as Tool,
  AppBar,
  CircularProgress,
  useMediaQuery,
  styled,
  Divider,
  Tooltip,
  useTheme,
} from '@mui/material';
import {
  SkipNext,
  SkipPrevious,
  Remove,
  Add,
  Fullscreen,
  FullscreenExit,
} from "@mui/icons-material";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import Lottie from 'lottie-web-react'
import WrappedPage from './WrappedPage';
import { useTranslation } from 'react-i18next';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  // [`& .${tooltipClasses.tooltip}`]: {
  backgroundColor: theme.palette.common.white,
  color: 'rgba(0, 0, 0, 0.87)',
  boxShadow: theme.shadows[1],
  fontSize: 11,
  // },
}));

const Toolbar = styled(Tool)(({ theme }) => ({
  minHeight: "auto !important",
  [theme.breakpoints.up("xs")]: {
    minHeight: "auto !important",
  },
}));
const IconButton = styled(IconBut)(({ theme }) => ({
  paddingLeft: 3,
  paddingRight: 3,
  '&:hover': {
    outline: 'none !important',
  },
  '&:focus': {
    outline: 'none !important',
  }
}));

const PageCustom = styled(Page)(({ theme }) => ({
  "& .react-pdf__Page__svg": {
    display: 'flex !important'
  }
}));

const SimpleBarCustom = styled(SimpleBar)(({ theme }) => ({
  ['@media only screen and (min-width: 812px)']: {
    "& .simplebar-track.simplebar-vertical": {
      width: '18px !important'
    },
    "& .simplebar-track.simplebar-horizontal": {
      height: '22px !important'
    },
    "& .simplebar-track.simplebar-horizontal .simplebar-scrollbar": {
      height: '18px !important'
    },
  },
}));

const TitleCustom = styled(Typography)(({ theme }) => ({
  width: '100% !important',
  maxHeight: '20px',
}));

const VisorPDF = (props) => {
  const [isFullScreen, setisFullScreen] = useState(false);
  const [scale, setScale] = useState(2);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(null);
  const theme = useTheme()
  const location = useLocation();
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const xsScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const pdfRef = useRef();
  const [containerHeight, setContainerHeight] = useState(500);
  const { t }= useTranslation(); 

  const openFullscreen = () => {
    pdfRef.current.requestFullscreen();
  };

  const closeFullscreen = () => {
    /* pdfRef.current.exitFullscreen(); */
    document.exitFullscreen();
  };

  const zoomPlus = () => {
    if (scale <= 2) {
      setScale(scale + 0.1);
    }
  };
  const zoomMinus = () => {
    if (scale >= 0.1) {
      setScale(scale - 0.1);
    }
  };
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  const changePage = (offset) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  };

  const previousPage = () => {
    changePage(-1);
  };

  const nextPage = () => {
    changePage(1);
  };
  useEffect(() => {
    console.log("...............Ejecuta resize.INIT.............: ", props.porcentaje)
    const newHeight = props.porcentaje == undefined || props.porcentaje == null ? calculateHeight(80) : calculateHeight(props.porcentaje); // Calcular nueva altura en vh
    console.log("...............Ejecuta resize.INIT.............: ", newHeight)
    setContainerHeight(newHeight);
  }, []);

  useEffect(() => {
    const setFullscreen = () => {
      setisFullScreen(!isFullScreen);
    };
    document.addEventListener("fullscreenchange", setFullscreen);
    return () =>
      document.removeEventListener("fullscreenchange", setFullscreen);
  });

  useEffect(() => {
    if (!isFullScreen && pdfRef.current) {
      // console.log("Entro IF VISOR**********", smScreen, xsScreen)
      if (smScreen && xsScreen) {
        setScale(0.7);
      } else if (smScreen) {
        setScale((pdfRef.current.clientWidth * 0.9) / 1000 + 0.5);
      } else if (xsScreen) {
        setScale((pdfRef.current.clientWidth * 0.9) / 1000);
      } else {
        setScale((pdfRef.current.clientWidth * 0.9) / 1000 + 0.5);
      }
    } else {
      // console.log("Entro else VISOR**********")
      setScale(1);
    }
  }, [isFullScreen, smScreen, xsScreen]);

  const calculateHeight = (percentage) => {
    console.log("percentage++++++++++", percentage + 10)
    const windowHeight = window.innerHeight;
    return windowHeight * ((percentage) / 100);
  };

  const handleResize = () => {
    const newHeight = props.porcentaje == undefined || props.porcentaje == null ? calculateHeight(80) : calculateHeight(props.porcentaje);
    console.log("...............Ejecuta resize visor+++..............: ", newHeight)
    setContainerHeight(newHeight);
  };

  useEffect(() => {
    // Agregar el event listener en el montaje del componente
    window.addEventListener('resize', handleResize);

    // Limpiar el event listener en el desmontaje del componente
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // El segundo parámetro del useEffect es un arreglo vacío para ejecutarlo solo una vez al montar/desmontar el componente

  const PdfContainer = styled(Box, {
    shouldForwardProp: (prop) => prop != "isfullscreen",
  })(({ height, isfullscreen, theme }) => ({
    width: "100%",
    margin: "10px auto",
    height: `${containerHeight}px`,
    overflow: "hidden",
    position: "relative",
    borderBottom: '1px solid gray',
    "& .react-pdf__Document": {
      backgroundColor: "#888",
      height: `${containerHeight}px`,
      display: "flex",
      flexDirection: "column",
      border: "0.5px solid gray",
    },
    "& .react-pdf__Page": {
      flexGrow: 1,
      display: "block",
      padding: "8px 8px",
    },
    "& .react-pdf__Page__annotations": {
      display: "none",
    },
    "& canvas": {
      padding: "10px 0px",
      /*  paddingRight: 90, */
      margin: "0 auto",
    },
    [theme.breakpoints.down("sm")]: {
      "& .react-pdf__Page": {
        padding: "5px 5px",
      },
      "& canvas": {
        // padding: "10px 0",
      },
    },
  }));

  return (
    <Fragment>
      {/* {console.log("height={props.height}****: ", props.height)} */}
      <PdfContainer
        ref={(el) => (pdfRef.current = el)}
        isfullscreen={isFullScreen}
        height={props.height === undefined || props.height != null ? '50vh' : props.height}
      >
        <Document
          className="d-flex flex-column align-items-center"
          file={props.pdfUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<Spinner />}
          error={<Box></Box>}
          noData={<Box></Box>}
        >
          <AppBar position="sticky" sx={{ bgcolor: "#000", zIndex: 1000 }}>
            <Toolbar>
              <TitleCustom
                variant="subtitle2"
                component="div"
                sx={(theme) => ({
                  // maxWidth: 100,
                  flexGrow: 1,
                  fontSize: "14px !important",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  [theme.breakpoints.down("sm")]: {
                    fontSize: "12px !important",
                  },
                })}
              >
                {t("general_pdf_viewer")}
                {/* {props.pdfName ?? "Visor PDF"} */}
              </TitleCustom>
              <Divider />
              <LightTooltip placement="top" title="Acercar">
                <IconButton color="inherit" onClick={zoomPlus}
                  style={{
                    '&:hover': {
                      outline: 'none !important',
                    },
                    '&:focus': {
                      outline: 'none !important',
                    }
                  }}>
                  <Add sx={{ color: "#FFF  !important" }} fontSize="small" />
                </IconButton>
              </LightTooltip>
              <LightTooltip placement="top" title="Alejar"
                style={{
                  '&:hover': {
                    outline: 'none !important',
                  }
                }}>
                <IconButton color="inherit" onClick={zoomMinus}
                  style={{
                    '&:hover': {
                      outline: 'none !important',
                    },
                    '&:focus': {
                      outline: 'none !important',
                    }
                  }}>
                  <Remove sx={{ color: "#FFF !important" }} fontSize="small" />
                </IconButton>
              </LightTooltip>
            </Toolbar>
          </AppBar>
          <SimpleBarCustom
            style={{ width: "100%", height: "100%", overflow: "auto" }}
          >
            {Array.from(
              new Array(numPages),
              (el, pageIndex) => (
                <div
                  style={{ position: 'relative' }}
                  key={pageIndex + '-div'}>
                  <WrappedPage
                    pageNumber={pageIndex + 1}
                    scale={scale}
                    key={pageIndex + '-page'}
                    originalWidth={pdfRef.current?.clientWidth}
                    originalHeight={pdfRef.current?.clientHeight}
                  />
                </div>
              ))}

            {/* {Array.from(
              new Array(numPages),
              (el, index) => {
                const isCurrentlyRendering = numPages === index + 1;  // true
                const isLastPage = numPages === index + 1; // false
                const needsCallbackToRenderNextPage = isCurrentlyRendering && !isLastPage;  // true
                return (
                  <Page
                    key={`page_${index + 1}`}
                    onRenderSuccess={
                      needsCallbackToRenderNextPage ? this.onRenderSuccess : null
                    }
                    style={{ overflow: 'auto !important' }}
                    scale={scale}
                    loading={"Cargando"}
                    pageNumber={index + 1}
                  />
                );
              }
            )} */}
          </SimpleBarCustom>
        </Document>
      </PdfContainer>
    </Fragment>
  );
};

const Spinner = () => {
  const { t } = useTranslation();

  return (<span>{t("viewfinder_loading_text")}</span>);
};

export default VisorPDF;
